import { nowInfoFor } from "../epg/nowInfo.js";

/**
 * The banner a full-screen zap shows for 3 s: the channel, and what is on now and
 * next (owner, 2026-10-19: "zap banner gets now/next"). The listings come from the
 * guide behind the player (nowInfo.ts); with none, it is the name alone, as before.
 * Nothing in it is focusable, so the zap and its navigation are unchanged.
 */
const time = (iso: string) => new Date(iso).toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });

export function ZapBanner({ name }: { name: string }) {
  const info = name ? nowInfoFor(name) : null;
  // The lookup falls back to the selected channel when the name is unknown; only
  // show listings that are really this channel's.
  const own = info && info.channel.name === name ? info : null;
  return (
    <div className="player-surface__zap-banner" role="status">
      <span className="player-surface__zap-name">{name}</span>
      {own?.now && (
        <span className="player-surface__zap-line">
          <span className="player-surface__zap-label">Now</span> {own.now.title}
          <span className="player-surface__zap-time"> until {time(own.now.end)}</span>
        </span>
      )}
      {own?.next && (
        <span className="player-surface__zap-line player-surface__zap-line--next">
          <span className="player-surface__zap-label">Next</span> {time(own.next.start)} {own.next.title}
        </span>
      )}
    </div>
  );
}
